var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38505 15.8259L17.6083 7.60268C17.7779 7.43304 17.8627 7.23214 17.8627 7C17.8627 6.76786 17.7779 6.56696 17.6083 6.39732L16.2422 5.03125C16.0725 4.86161 15.8717 4.77678 15.6395 4.77678C15.4074 4.77678 15.2065 4.86161 15.0368 5.03125L8.78237 11.2857L5.95647 8.45982C5.78683 8.29018 5.58594 8.20536 5.3538 8.20536C5.12165 8.20536 4.92076 8.29018 4.75112 8.45982L3.38504 9.82589C3.2154 9.99554 3.13058 10.1964 3.13058 10.4286C3.13058 10.6607 3.2154 10.8616 3.38504 11.0312L8.17969 15.8259C8.34933 15.9955 8.55022 16.0804 8.78237 16.0804C9.01451 16.0804 9.2154 15.9955 9.38505 15.8259ZM20.7824 4V16.8571C20.7824 17.9196 20.4029 18.8259 19.644 19.5759C18.894 20.3348 17.9877 20.7143 16.9252 20.7143H4.06808C3.00558 20.7143 2.09487 20.3348 1.33594 19.5759C0.585938 18.8259 0.210938 17.9196 0.210938 16.8571V4C0.210938 2.9375 0.585938 2.03125 1.33594 1.28125C2.09487 0.52232 3.00558 0.142856 4.06808 0.142856H16.9252C17.9877 0.142856 18.894 0.52232 19.644 1.28125C20.4029 2.03125 20.7824 2.9375 20.7824 4Z",
    fill: "#1E334E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked1);
export default __webpack_public_path__ + "static/media/checked1.e4ed4254cc4e1f78fece8852c9d7743c.svg";
export { ForwardRef as ReactComponent };